import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js';

export const TagsAds = () => {
  const [tags, setTags] = useState([]);
  const [adsTags, setAdsTags] = useState([]);

  const fetchAds = async () => {
    try {
      const response = await axios.get('/c3.json');
        let tagdata1 = ["{'v1':'7y6vSpntmKQnHT5lY5Kgrw==','k1':'ivIkqvbH2zwRkVj0iDLllA=='}",
          "{'v1':'2Llf7JmIKPkNhvVTE0u60A==','k1':'r6i8bIl8yTzBgbslwbitzw=='}",
          "{'v1':'Yapv1278yT2MG8zLCdpwYQ==','k1':'3oCvNkfPQfevtUFureEfCg=='}",
          "{'v1':'yhmFKRIGL+ooLBPVCE5HQQ==','k1':'SueA9r/Paq/TwR6j776iuQ=='}",
          "{'v1':'W/gB/ZgDXUOcExHGUGHM+A==','k1':'sOTjSdLb1NJmMIGNWTUZVQ=='}",
          "{'v1':'pywipxxsGM3CxZcsNp7cBA==','k1':'49tXBJz+EuT4OwH23VL1DQ=='}",
          "{'v1':'PVaN7ntl9dWEFdBgi5voLA==','k1':'pDo8lbIkyB4GHa+3kswqjg=='}",
          "{'v1':'KnytOon/d9RgBXrElqizNA==','k1':'BFDJjvXvlvYH0NIcgtG73g=='}",
          "{'v1':'Dj+6GOUSc7pwvGfxuBZjUQ==','k1':'PdQ/M6DBAZdcuSiu6mg7Dg=='}",
          "{'v1':'2AUcMd0P4M5lGH7uEltZxg==','k1':'y6ot3jMntrpUCVQog6wB1Q=='}",
          "{'v1':'S2qc4nr+7A17l0wPQiFdBQ==','k1':'KV8jj/AQSSwkNxSxlzWahQ=='}"];

         let tagdata2 = ["{'v1':'MICtIW0w8jeR+KUGLkuuQw==','k1':'1X75zSFFudcNMKrcGxwZuQ=='}",
          "{'v1':'20W0hT2HZGJEQetx9NPtbg==','k1':'oJ0fds0riGLbHOePwQQi9w=='}",
          "{'v1':'iXAl2oawEyOIsjX4zcJC1w==','k1':'aSkQ2fGBkjl5X8Gi2uxa6g=='}",
          "{'v1':'40S9t9C9343xkNFDSbvFcA==','k1':'EoFFUb0YE6T8gONGIZVMDw=='}",
          "{'v1':'pnBPYJC+HhpmRJOPMb9EQg==','k1':'otr6cjNfQ99cS/xjyDPTMQ=='}",
          "{'v1':'HhdIXQaEGocmmCR/JIrIag==','k1':'fLugubnrT6ifiNcJY3zPOQ=='}",
          "{'v1':'q6imACPHUGe+X7oovP9wWQ==','k1':'QNsFzm04wPy+XUTnVEIV+A=='}",
          "{'v1':'LX0VxqjiOH/9H4SX21Xw/g==','k1':'XFUSiMwlqNU8GN0MnXT+MQ=='}",
          "{'v1':'frbx5JOtmSaVlNkQ1vCRbg==','k1':'XxXvque5na+6PDL0mJrqjQ=='}"];

          let tagdata3 = ["{'v1':'qgf99BblNUVVW9TLUZybpg==','k1':'bh4nbrfBGCwBEY0kKFXbog=='}",
          "{'v1':'YNNjILe2v8aX/03gaTO3Tw==','k1':'DVXZpvJta2FlDH4xaEzxBQ=='}",
          "{'v1':'YX4BSpCiaoaAkrPYCgkhSw==','k1':'bkjkwIZUoQV1txve0abfWA=='}",
          "{'v1':'7KgJIpYHcvAz6VIEPo+Vww==','k1':'2SXQQHy5DLXHbFYk6Ct/bA=='}",
          "{'v1':'uTKXGWqxZPpNxh/gsPDh1A==','k1':'I88ZVBdjNSOY801JURXAPg=='}",
          "{'v1':'EENOT1XfN2ONDpzobYtVwg==','k1':'GKVBtAEFzRFHt3P8MYhA+A=='}"
          ];

          let tagdata4 = ["{'v1':'6WeWimIOFn1gqcq7aS2jOQ==','k1':'2jS0d1n8jQE8FtgvnsWSZg=='}",
          "{'v1':'+lyi5NXAj/f2QL88VnkhZw==','k1':'5VsxKtByCZ9P0Or6AslcDA=='}",
          "{'v1':'suBYbkCXWx6CTqAwJXXq8w==','k1':'OikB4UPkILwPwelg5aU2/g=='}",
          "{'v1':'Le455QivI9X06HIM+nXVaQ==','k1':'FnT1MdB0A1LAiXOK/OoQYA=='}",
          "{'v1':'sy/55sbnY3LQc3Fq3F+euQ==','k1':'+0M1tYI4gpMRfrKwTWQqqw=='}",
          "{'v1':'b+jdcFOqv9KENi/ytjh38g==','k1':'qnx/xOeFQr7ZCOrtlneHsg=='}",
          "{'v1':'6wzXT8Gb+fbSw1jBBTptDg==','k1':'uvP4EutYyAvjzsC3FLIvFA=='}",
          "{'v1':'/19yhgYk2UuA7rgH0mu9og==','k1':'pvfgKL1y3FJiS+NRX4X3bA=='}",
          "{'v1':'R+dU64J9f8Mz0P1/4ux7Dw==','k1':'AYIndGi687EDy/VvWDe/gg=='}"];
              
          let tagdata5 = ["{'v1':'xrDDdx98ut5OdVUAfCLCkw==','k1':'EUpZRK1isQeime/+vHgUEg=='}",
          "{'v1':'6IXvLrYcpcDee3EbDtF+pg==','k1':'dDUEjyP0Puo/EuV1j9Q/6w=='}",
          "{'v1':'t3/8KFmUgJ/4bd56jezsqA==','k1':'wHbY8N8vLExLvnBZwuBUBg=='}",
          "{'v1':'WlnmXUP15uj5mTk/xibOQA==','k1':'FefdZbmWadIE8X/mvHIXMg=='}",
          "{'v1':'mtB9RZVbcGpNXDoPPCWZKg==','k1':'Wd18WPXNMyLNJIycbqPr/w=='}",
          "{'v1':'lNOwYaA9wKL1g0SsQ2YqVQ==','k1':'V1U77u4hRU9dYbiQTCKbVQ=='}",
          "{'v1':'y8CF+aYNM9wn4/bz2QygeQ==','k1':'RAVuQhk7VMu9UQfxDc3www=='}",
          "{'v1':'TDTY6UJzQQnQOPFgdYTMYA==','k1':'dDSSn6rx4VmQeC2mKeGCuQ=='}"];

          let tagdata6 = ["{'v1':'1/HA8KivcVAadFZQZn8Wcg==','k1':'b7wcKWOyPxqikO4RahpT5A=='}",
          "{'v1':'yIQFbtJj7txngYRogKss8w==','k1':'6KHwtnuk5C6keWpHBO/whQ=='}",
          "{'v1':'LOrf2HS/HNW8nHz49L2TIQ==','k1':'F3zculFSaD7mrpc6NlNu4g=='}",
          "{'v1':'Ey82TH0hjZSLXvJknM8xuA==','k1':'WNhEZg7HYD9TAoBQTo0WtA=='}",
          "{'v1':'jFMpMnNTUemdUmHnlK+JZw==','k1':'74G5cZaMp35ukaq3nnQR1w=='}",
          "{'v1':'yQg6wpIyuM+Hp9fnpflTRQ==','k1':'JfpxH4dX3v+l9k8tD1DRnw=='}"];

          let tagdata7 = ["{'v1':'YA24uA/9JrrA+hLHdnY/bQ==','k1':'0ztWqNBanwwpXmSwVkxbUA=='}",
          "{'v1':'wvQDzLgrc/fZ+0hZI8nxMw==','k1':'E8c84usVoT1LTkFGZq0kAQ=='}",
          "{'v1':'6EsIgtvrMFNz3mPbAw5B2A==','k1':'r6sbZ5Q6pBIUtDGHQWpkbQ=='}",
          "{'v1':'Yr3ihHUWNp4By0RNsUZ0fg==','k1':'WoJMgmYQHR9sRWb61Ah18A=='}",
          "{'v1':'asgwy1ntJSHW/KemcVU01A==','k1':'m7lLGzOaK9qFPLBAuPokPA=='}",
          "{'v1':'6RzqqEOai4Qmb8MDLTvreA==','k1':'p/rTue1nzxqEjxyd/MwOFA=='}",
          "{'v1':'5OKsHp2T1/g+aAH/Bn/haQ==','k1':'qCC0eEQJ5AGEhML8ZRQteA=='}"];

          tagdata1 = getArray(tagdata1);
          tagdata2 = getArray(tagdata2);
          tagdata3 = getArray(tagdata3);
          tagdata4 = getArray(tagdata4);
          tagdata5 = getArray(tagdata5);
          tagdata6 = getArray(tagdata6);
          tagdata7 = getArray(tagdata7);
          let adsTagsData = response.data.adsTags;
          const adsTagsArray = Object.values(adsTagsData);
          adsTagsArray.forEach((item) => {
             // 解析密文和 IV
              const cipherText = CryptoJS.enc.Base64.parse(item.title[0]); 
              const iv = CryptoJS.enc.Base64.parse(item.title[1]); 
              // 使用固定密钥进行解密
              const key = CryptoJS.enc.Utf8.parse("aafb2b88c91ac2b0"); // 固定的16字节密钥
              // 解密操作
              const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherText }, key, { iv: iv });
              let plainText = decrypted.toString(CryptoJS.enc.Utf8);
              plainText = plainText.replace(/[\x00-\x1F\x7F-\x9F\x10]+/g, '').trim();
              item.title = plainText;
          });

      // 对 adsTags 按顺序转换为数组
      // const sortedAdsTags = Object.values(adsTagsData).sort((a, b) => a.title.localeCompare(b.title));
      let tagsData = [tagdata1, tagdata2, tagdata3, tagdata4,tagdata5,tagdata6,tagdata7];
      setTags(tagsData);
      setAdsTags(adsTagsData);
    } catch (error) {
      console.error("Error fetching ads:", error);
    }
  }
  useEffect(() => {
    fetchAds();
  }, []);

  function getArray(tagarray) {
    return tagarray.map((item) => {
      const parsedItem = JSON.parse(item.replace(/'/g, '"')); 
      // 解析密文和 IV
      const cipherText = CryptoJS.enc.Base64.parse(parsedItem.v1); 
      const iv = CryptoJS.enc.Base64.parse(parsedItem.k1); 
      // 使用固定密钥进行解密
      const key = CryptoJS.enc.Utf8.parse("aafb2b88c91ac2b0"); // 固定的16字节密钥
      // 解密操作
      const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherText }, key, { iv: iv });
      let plainText = decrypted.toString(CryptoJS.enc.Utf8);
      plainText = plainText.replace(/[\x00-\x1F\x7F-\x9F\x10]+/g, '').trim();
      parsedItem.title = plainText;
      return parsedItem; // Return the modified item
    });
  }
  
  

  const createRightLinks = (items) => {
    const itemArray = Array.isArray(items) ? items : Object.values(items);
    const displayedItems = itemArray.slice(0, 7);
    const shouldShowMore = itemArray.length > 8;

    if (shouldShowMore) {
      displayedItems.push({ title: "更多", link: "/tags" });
    }
    return displayedItems;
  };
  const adsLinks = createRightLinks(adsTags);

return (
  <nav className="w-full flex flex-col items-start">
    {/* 动态渲染 tags 中的每一个分类 */}
    {Object.entries(tags).map(([category, items], index) => {
      const rightLinks = createRightLinks(items);
      
      return <LeftRightSection key={category} text={category} links={rightLinks} rowIndex={index} />;
    })}

    {/* 渲染 adsTags 的部分 */}
    {/* <LeftRightSection text="广告" links={adsLinks} rowIndex={1} /> */}
    {/* <LeftRightSection text="广告2" links={adsLinks}  rowIndex={2} /> */}
  </nav>
);
};

const LeftRightSection = ({ text, links, rowIndex }) => {
  const firstRowLinks = links.slice(0, 4);
  const secondRowLinks = links.slice(4);
  if(text == 0){
    text = "系列";
  }else if (text == 1){
    text = "招式";
  }else if (text == 2){
    text = "情节";
  }else if (text == 3){
    text = "职业";
  }else if (text == 4){
    text = "服装场景";
  }else if (text == 5){
    text = "身材";
  }else if (text == 6){
    text = "其他";
  }
  return (
    <div className={`w-full my-2 pt-2 pb-2 flex items-center ${rowIndex % 2 === 1 ? "bg-tb" : ""}`}>
      {/* 左侧标签 */}
      <div className="w-16 flex items-center justify-start">
        <span className="text-sm font-bold text-tw">{text}</span>
      </div>
      {/* 右侧对应值 */}
      <div className="w-full flex flex-col">
        {/* 第一行 */}
        <div className="flex items-start space-x-2">
          {firstRowLinks.map((link, index) => (
            <div key={index} className="w-20 h-full flex items-center justify-center">
              {link.title === "更多" ? (
                <NavLink
                  to={link.title}
                  className="text-tw hover:underline"
                >
                  更多
                </NavLink>
              ) : (
                // <NavLink to={link.link}> <span className="text-sm text-tw">{link.title || link}</span> </NavLink>
                <NavLink 
                to={`/tags/${link.title}/`} 
                className="text-sm text-tw hover:underline"
              >
                {link.title || link}
              </NavLink>
              
              )}
            </div>
          ))}
        </div>
        {/* 第二行 */}
        {secondRowLinks.length > 0 && (
          <div className="flex items-start space-x-2 mt-2">
            {secondRowLinks.map((link, index) => (
              <div key={index} className="w-20 h-full flex items-center justify-center">
                {link.title === "更多" ? (
                  <NavLink
                    to={link.link}
                    className="text-tw hover:underline"
                  >
                    更多
                  </NavLink>
                ) : (
                  // <span className="text-sm text-tw">{link.title || link}</span>
                  <NavLink 
                  to={`/tags/${link.title}/`} 
                  className="text-sm text-tw hover:underline"
                >
                  {link.title || link}
                </NavLink>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};